import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-confirm-dialog',
    imports: [
    ],
    templateUrl: './confirm-dialog.component.html',
    styleUrl: './confirm-dialog.component.sass'
})
export class ConfirmDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { text:string, header:string, delete: boolean }
    ) {
    }

    onClose(): void {
        this.dialogRef.close();
    }

    onSubmit(): void {
        this.dialogRef.close(true);
    }

}
